{
  "app.name": "تریپی",
  "app.tagline": "همسفر هوشمند سفرهای ایران",
  "common.ok": "باشه",
  "common.cancel": "انصراف",
  "common.save": "ذخیره",
  "common.delete": "حذف",
  "common.edit": "ویرایش",
  "common.back": "بازگشت",
  "common.next": "بعدی",
  "common.done": "تمام",
  "common.retry": "تلاش دوباره",
  "common.more": "بیشتر",
  "common.less": "کمتر",
  "common.seeAll": "همه",
  "common.share": "اشتراک‌گذاری",
  "common.copy": "کپی",
  "common.copied": "کپی شد",
  "common.loading": "در حال بارگذاری…",
  "common.search": "جست‌وجو",
  "common.close": "بستن",
  "common.confirm": "تأیید",
  "common.today": "امروز",
  "common.tomorrow": "فردا",
  "common.yesterday": "دیروز",
  "common.free": "رایگان",
  "common.perNight": "هر شب",
  "common.perPerson": "هر نفر",
  "common.toman": "تومان",
  "common.day": "{n, plural, one {# روز} other {# روز}}",
  "common.night": "{n, plural, one {# شب} other {# شب}}",
  "common.adult": "{n, plural, one {# بزرگسال} other {# بزرگسال}}",
  "common.child": "{n, plural, one {# کودک} other {# کودک}}",
  "common.reviewCount": "{n, plural, =0 {بدون نظر} one {# نظر} other {# نظر}}",
  "common.rating": "امتیاز",
  "common.new": "جدید",
  "common.offline": "آفلاین هستی؛ اطلاعات ممکن است قدیمی باشد.",
  "common.updateAvailable": "نسخهٔ جدید آماده است",
  "common.update": "به‌روزرسانی",
  "common.errorTitle": "مشکلی پیش آمد",
  "common.errorBody": "دوباره تلاش کن. اگر ادامه داشت با ما در میان بگذار.",
  "common.notFound": "چیزی پیدا نشد",
  "common.dismiss": "بعداً",
  "nav.today": "امروز",
  "nav.trips": "سفرها",
  "nav.explore": "کشف",
  "nav.profile": "پروفایل",
  "nav.add": "افزودن",
  "nav.addTicket": "افزودن بلیت",
  "nav.planTrip": "برنامه‌ریزی سفر",
  "onboarding.slide1.title": "بلیت‌هایت را زنده دنبال کن",
  "onboarding.slide1.body": "پرواز، قطار و اتوبوس را روی نقشه ببین؛ تأخیر و گیت را قبل از همه بفهم.",
  "onboarding.slide2.title": "سفرت را برایت برنامه‌ریزی می‌کنیم",
  "onboarding.slide2.body": "بودجه‌ات را بگو؛ هتل، جاهای دیدنی و مسیر هر روز را می‌چینیم.",
  "onboarding.slide3.title": "شهر را کشف کن",
  "onboarding.slide3.body": "بهترین جاها با امتیاز و نظر مسافرها.",
  "onboarding.start": "شروع",
  "onboarding.login": "ورود",
  "onboarding.skip": "رد شدن",
  "auth.phone.title": "شماره موبایل",
  "auth.phone.subtitle": "کد تأیید برایت پیامک می‌کنیم",
  "auth.phone.placeholder": "۰۹۱۲ ۳۴۵ ۶۷۸۹",
  "auth.phone.invalid": "شماره موبایل معتبر نیست",
  "auth.phone.submit": "دریافت کد",
  "auth.phone.terms": "با ادامه، <terms>قوانین</terms> و <privacy>حریم خصوصی</privacy> را می‌پذیری.",
  "auth.otp.title": "کد تأیید",
  "auth.otp.subtitle": "کد ۶ رقمی ارسال‌شده به {phone} را وارد کن",
  "auth.otp.resend": "ارسال دوباره",
  "auth.otp.devHint": "کد آزمایشی (محیط توسعه) — لمس کن",
  "auth.otp.resendIn": "ارسال دوباره تا {seconds} ثانیه دیگر",
  "auth.otp.editPhone": "ویرایش شماره",
  "auth.otp.wrong": "کد اشتباه است",
  "auth.otp.expired": "کد منقضی شده؛ دوباره درخواست کن",
  "auth.otp.locked": "تلاش‌های زیاد؛ کمی بعد دوباره امتحان کن",
  "auth.rateLimited": "کمی صبر کن و دوباره تلاش کن ({seconds} ثانیه)",
  "auth.name.title": "اسمت چیه؟",
  "auth.name.placeholder": "نام و نام خانوادگی",
  "auth.logout": "خروج",
  "auth.logoutConfirm": "از حساب خارج می‌شوی؟",
  "today.greeting.morning": "صبح بخیر{name}",
  "today.greeting.afternoon": "ظهر بخیر{name}",
  "today.greeting.evening": "عصر بخیر{name}",
  "today.greeting.night": "شب بخیر{name}",
  "today.nextSegment": "سفر بعدی",
  "today.untilDeparture": "تا حرکت",
  "today.untilArrival": "تا رسیدن",
  "today.todayPlan": "برنامهٔ امروز",
  "today.upcomingTrips": "سفرهای پیش‌رو",
  "today.empty.title": "هنوز سفری نداری",
  "today.empty.body": "بلیتت را اضافه کن تا زنده دنبالش کنی، یا بگذار سفرت را برنامه‌ریزی کنیم.",
  "today.quick.addTicket": "افزودن بلیت",
  "today.quick.plan": "برنامه‌ریزی سفر",
  "status.scheduled": "طبق برنامه",
  "status.on_time": "به‌موقع",
  "status.delayed": "تأخیر",
  "status.boarding": "در حال سوارشدن",
  "status.departed": "حرکت کرد",
  "status.en_route": "در مسیر",
  "status.arriving": "در حال رسیدن",
  "status.arrived": "رسید",
  "status.cancelled": "لغو شد",
  "status.diverted": "تغییر مسیر",
  "status.unknown": "نامشخص",
  "status.live": "زنده",
  "status.estimated": "تخمینی",
  "mode.flight": "پرواز",
  "mode.train": "قطار",
  "mode.bus": "اتوبوس",
  "tracking.gate": "گیت",
  "tracking.terminal": "ترمینال",
  "tracking.seat": "صندلی",
  "tracking.platform": "سکو",
  "tracking.wagon": "واگن",
  "tracking.bay": "جایگاه",
  "tracking.belt": "نوار چمدان",
  "tracking.pnr": "کد رزرو",
  "tracking.scheduled": "برنامه",
  "tracking.actual": "واقعی",
  "tracking.estimated": "تخمینی",
  "tracking.departure": "حرکت",
  "tracking.arrival": "رسیدن",
  "tracking.delayMinutes": "{n} دقیقه تأخیر",
  "tracking.timeline": "روند سفر",
  "tracking.delayHistory": "تاریخچهٔ تأخیر",
  "tracking.details": "جزئیات",
  "tracking.follow": "دنبال‌کردن روی نقشه",
  "tracking.liveLost": "اتصال زنده قطع شد",
  "tracking.lastUpdate": "آخرین به‌روزرسانی {time}",
  "tracking.noLive": "اطلاعات زنده در دسترس نیست",
  "tracking.cancelledBanner": "این سرویس لغو شده است",
  "tracking.findAlternative": "جست‌وجوی جایگزین",
  "tracking.addToCalendar": "افزودن به تقویم",
  "tracking.removeTicket": "حذف بلیت",
  "tracking.rateTrip": "امتیاز به این سفر",
  "tracking.step.checkin": "پذیرش",
  "tracking.step.boarding": "سوارشدن",
  "tracking.step.departed": "حرکت",
  "tracking.step.enRoute": "در مسیر",
  "tracking.step.arrived": "رسیدن",
  "tracking.progress": "{percent} مسیر طی شده",
  "addTicket.title": "افزودن بلیت",
  "addTicket.chooseMode": "نوع سفر را انتخاب کن",
  "addTicket.pasteSms": "متن پیامک یا کد رزرو را بچسبان",
  "addTicket.byNumber": "شمارهٔ پرواز/قطار",
  "addTicket.bySearch": "جست‌وجوی برنامه",
  "addTicket.number": "شماره",
  "addTicket.numberHint.flight": "مثلاً IR452",
  "addTicket.numberHint.train": "مثلاً ۱۱۲",
  "addTicket.numberHint.bus": "شرکت و سرویس",
  "addTicket.date": "تاریخ",
  "addTicket.from": "مبدأ",
  "addTicket.to": "مقصد",
  "addTicket.search": "جست‌وجو",
  "addTicket.noResults": "پیدا نشد؛ با شماره اضافه کن",
  "addTicket.confirm": "تأیید بلیت",
  "addTicket.optional": "اختیاری",
  "addTicket.passenger": "نام مسافر",
  "addTicket.addToTrip": "افزودن به سفر",
  "addTicket.newTrip": "سفر جدید",
  "addTicket.add": "افزودن",
  "addTicket.duplicate": "این بلیت قبلاً اضافه شده",
  "addTicket.added": "بلیت اضافه شد",
  "addTicket.viewTrip": "مشاهدهٔ سفر",
  "trips.title": "سفرها",
  "trips.upcoming": "آینده",
  "trips.past": "گذشته",
  "trips.empty.title": "هنوز سفری نساخته‌ای",
  "trips.empty.body": "یک بلیت اضافه کن یا سفر جدیدی برنامه‌ریزی کن.",
  "trips.tab.overview": "کلی",
  "trips.tab.tickets": "بلیت‌ها",
  "trips.tab.itinerary": "برنامه",
  "trips.tab.map": "نقشه",
  "trips.tab.budget": "بودجه",
  "trips.deleteConfirm": "این سفر حذف شود؟",
  "trips.archived": "بایگانی شد",
  "trips.hotel": "هتل",
  "trips.dayN": "روز {n}",
  "trips.regenerate": "بازتولید",
  "trips.regenerateDay": "بازتولید این روز",
  "trips.shareTrip": "اشتراک سفر",
  "trips.status.upcoming": "پیش‌رو",
  "trips.status.active": "در جریان",
  "trips.status.done": "تمام‌شده",
  "planner.title": "برنامه‌ریزی سفر",
  "planner.step.destination": "مقصد",
  "planner.step.dates": "تاریخ",
  "planner.step.travelers": "مسافرها",
  "planner.step.budget": "بودجه",
  "planner.step.style": "سبک سفر",
  "planner.step.review": "بازبینی",
  "planner.destination.title": "کجا می‌روی؟",
  "planner.destination.search": "نام شهر…",
  "planner.destination.popular": "شهرهای محبوب",
  "planner.dates.title": "کِی؟",
  "planner.dates.fromTickets": "از بلیت‌ها: {range}",
  "planner.dates.useTickets": "بر اساس بلیت‌ها",
  "planner.travelers.title": "چند نفر؟",
  "planner.travelers.adults": "بزرگسال",
  "planner.travelers.children": "کودک",
  "planner.travelers.solo": "تنها",
  "planner.travelers.couple": "دونفره",
  "planner.travelers.family": "خانوادگی",
  "planner.travelers.friends": "دوستان",
  "planner.budget.title": "بودجه",
  "planner.budget.have": "بودجه دارم",
  "planner.budget.estimate": "برآورد کن",
  "planner.budget.includeTickets": "شامل بلیت‌ها؟",
  "planner.budget.total": "کل بودجه",
  "planner.tier.economy": "اقتصادی",
  "planner.tier.mid": "متوسط",
  "planner.tier.premium": "لوکس",
  "planner.style.title": "چه سبکی؟",
  "planner.pace.relaxed": "آرام",
  "planner.pace.balanced": "متعادل",
  "planner.pace.packed": "فشرده",
  "planner.interests.title": "علاقه‌مندی‌ها",
  "planner.interest.history": "تاریخی",
  "planner.interest.gardens": "باغ و طبیعت",
  "planner.interest.food": "غذا",
  "planner.interest.shopping": "خرید",
  "planner.interest.religious": "زیارتی",
  "planner.interest.museum": "موزه",
  "planner.interest.art": "هنر",
  "planner.interest.nightlife": "شبانه",
  "planner.interest.family": "کودک‌پسند",
  "planner.interest.literature": "ادبی",
  "planner.hotel.minStars": "حداقل ستاره",
  "planner.hotel.nearCenter": "نزدیک مرکز",
  "planner.hotel.style.any": "فرقی ندارد",
  "planner.hotel.style.traditional": "سنتی",
  "planner.hotel.style.modern": "مدرن",
  "planner.hotel.style.boutique": "بوتیک",
  "planner.review.title": "همه‌چیز درست است؟",
  "planner.generate": "بساز",
  "planner.generating.hotel": "دنبال هتل می‌گردیم…",
  "planner.generating.places": "جاهای دیدنی را می‌چینیم…",
  "planner.generating.routes": "مسیرها را حساب می‌کنیم…",
  "planner.generating.budget": "بودجه را جمع می‌زنیم…",
  "planner.result.title": "برنامهٔ سفرت آماده است",
  "planner.result.underBudget": "{amount} زیر بودجه",
  "planner.result.overBudget": "{amount} بالای بودجه",
  "planner.result.changeHotel": "تغییر هتل",
  "planner.result.alternatives": "گزینه‌های دیگر",
  "planner.result.save": "ذخیرهٔ سفر",
  "planner.result.regenerate": "بازتولید",
  "planner.item.swap": "تغییر",
  "planner.item.remove": "حذف",
  "planner.item.lock": "قفل",
  "planner.item.unlock": "بازکردن قفل",
  "planner.item.locked": "قفل‌شده",
  "planner.item.details": "جزئیات مکان",
  "planner.item.navigate": "مسیریابی",
  "planner.item.addPlace": "افزودن مکان",
  "planner.budgetInfeasible": "با این بودجه برنامه‌ای پیدا نشد؛ حداقل حدود {amount} لازم است.",
  "planner.explain.highly_rated": "امتیاز بالا",
  "planner.explain.iconic": "دیدنی شاخص",
  "planner.explain.near_previous": "نزدیک مقصد قبلی",
  "planner.explain.near_hotel": "نزدیک هتل",
  "planner.explain.budget_friendly": "مقرون‌به‌صرفه",
  "planner.explain.open_late": "تا دیروقت باز",
  "planner.explain.sunset_spot": "مناسب غروب",
  "planner.explain.local_favorite": "محبوب محلی‌ها",
  "planner.explain.day_trip": "گشت یک‌روزه",
  "planner.explain.locked_by_you": "قفل‌شده توسط تو",
  "planner.explain.hot_weather_indoor": "سرپوشیده برای گرما",
  "planner.explain.best_morning": "بهترین وقت: صبح",
  "itinerary.title": "برنامهٔ روز",
  "itinerary.now": "اکنون",
  "itinerary.walk": "پیاده {duration}",
  "itinerary.taxi": "تاکسی {duration}",
  "itinerary.car": "خودرو {duration}",
  "itinerary.checkin": "ورود به هتل",
  "itinerary.checkout": "خروج از هتل",
  "itinerary.meal.lunch": "ناهار",
  "itinerary.meal.dinner": "شام",
  "itinerary.meal.breakfast": "صبحانه",
  "itinerary.meal.cafe": "کافه",
  "itinerary.free": "وقت آزاد",
  "itinerary.navigateWith": "مسیریابی با…",
  "itinerary.app.neshan": "نشان",
  "itinerary.app.balad": "بلد",
  "itinerary.app.waze": "ویز",
  "itinerary.app.google": "گوگل‌مپس",
  "itinerary.cost": "هزینه",
  "explore.title": "کشف",
  "explore.popularCities": "شهرهای محبوب",
  "explore.nearYou": "نزدیک تو",
  "explore.weekly": "پیشنهاد هفته",
  "explore.topRated": "برترین‌ها",
  "explore.attractions": "دیدنی‌ها",
  "explore.hotels": "هتل‌ها",
  "explore.food": "غذا و کافه",
  "explore.planTo": "برنامه‌ریزی سفر به {city}",
  "explore.sort.rating": "امتیاز",
  "explore.sort.popularity": "محبوبیت",
  "explore.sort.distance": "فاصله",
  "explore.openNow": "الان باز است",
  "explore.closedNow": "الان بسته است",
  "explore.hours": "ساعت کار",
  "explore.address": "نشانی",
  "explore.website": "وب‌سایت",
  "explore.instagram": "اینستاگرام",
  "explore.wikipedia": "دربارهٔ این مکان در ویکی‌پدیا",
  "explore.entryFee": "ورودی",
  "explore.avgMeal": "میانگین هزینه",
  "explore.addToTrip": "افزودن به سفر",
  "explore.amenities": "امکانات",
  "explore.roomTypes": "اتاق‌ها",
  "explore.starsOfficial": "{n} ستاره",
  "explore.chooseForTrip": "انتخاب برای سفر",
  "explore.book": "رزرو",
  "explore.category.attraction": "دیدنی",
  "explore.category.restaurant": "رستوران",
  "explore.category.cafe": "کافه",
  "explore.category.hotel": "هتل",
  "explore.category.shopping": "خرید",
  "explore.category.nature": "طبیعت",
  "explore.category.religious": "زیارتی",
  "explore.category.museum": "موزه",
  "explore.category.park": "پارک",
  "explore.category.other": "سایر",
  "place.menu": "منو",
  "place.report": "گزارش اطلاعات نادرست",
  "place.report.title": "چه چیزی اشتباه است؟",
  "place.report.placeholder": "مثلاً: ساعت کاری عوض شده، جای مکان روی نقشه درست نیست…",
  "place.report.send": "ارسال گزارش",
  "place.report.thanks": "ممنون! بررسی می‌کنیم.",
  "source.snappfood": "اسنپ‌فود",
  "source.foursquare": "Foursquare",
  "service.snapp": "برو با اسنپ",
  "service.snappfood": "سفارش از اسنپ‌فود",
  "service.alibaba": "خرید بلیت از علی‌بابا",
  "service.buyTicket": "خرید بلیت",
  "itinerary.snapp": "اسنپ {duration}",
  "service.snappAction": "سفر با",
  "service.snappfoodAction": "سفارش غذا از",
  "hotel.checkin": "ورود از {time}",
  "hotel.checkout": "خروج تا {time}",
  "amenity.wifi": "وای‌فای",
  "amenity.breakfast": "صبحانه",
  "amenity.pool": "استخر",
  "amenity.spa": "اسپا",
  "amenity.parking": "پارکینگ",
  "amenity.restaurant": "رستوران",
  "amenity.gym": "باشگاه",
  "amenity.garden": "باغ",
  "amenity.kitchen": "آشپزخانه",
  "amenity.shuttle": "ترانسفر فرودگاهی",
  "amenity.view": "چشم‌انداز",
  "amenity.beach": "ساحل",
  "reviews.title": "نظرها",
  "reviews.write": "نوشتن نظر",
  "reviews.yourRating": "امتیاز تو",
  "reviews.titlePlaceholder": "عنوان (اختیاری)",
  "reviews.bodyPlaceholder": "تجربه‌ات را بنویس (حداقل ۲۰ حرف)",
  "reviews.addPhotos": "افزودن عکس",
  "reviews.submit": "ثبت نظر",
  "reviews.submitted": "نظرت ثبت شد",
  "reviews.pending": "در انتظار تأیید",
  "reviews.helpful": "مفید بود",
  "reviews.helpfulCount": "{n, plural, one {# نفر مفید دانستند} other {# نفر مفید دانستند}}",
  "reviews.report": "گزارش",
  "reviews.sort.recent": "جدیدترین",
  "reviews.sort.helpful": "مفیدترین",
  "reviews.visited": "بازدید در {date}",
  "reviews.empty": "هنوز نظری ثبت نشده؛ اولین نفر باش.",
  "reviews.needAuth": "برای ثبت نظر وارد شو",
  "budget.title": "بودجه",
  "budget.total": "جمع",
  "budget.of": "از {amount}",
  "budget.remaining": "باقی‌مانده",
  "budget.over": "بیش از بودجه",
  "budget.cat.tickets": "بلیت‌ها",
  "budget.cat.hotel": "اقامت",
  "budget.cat.food": "غذا",
  "budget.cat.attractions": "گشت و ورودی",
  "budget.cat.transport": "حمل‌ونقل",
  "budget.cat.misc": "سایر",
  "budget.adjust": "تنظیم بودجه",
  "budget.perDay": "روزانه",
  "budget.perPerson": "هر نفر",
  "budget.estimated": "برآورد",
  "budget.actual": "واقعی",
  "search.placeholder": "شهر، مکان، هتل…",
  "search.recent": "جست‌وجوهای اخیر",
  "search.cities": "شهرها",
  "search.places": "مکان‌ها",
  "search.hotels": "هتل‌ها",
  "search.myTrips": "سفرهای من",
  "search.tickets": "بلیت‌ها",
  "profile.title": "پروفایل",
  "profile.stats.trips": "سفر",
  "profile.stats.cities": "شهر",
  "profile.stats.reviews": "نظر",
  "profile.appearance": "ظاهر",
  "profile.theme": "پوسته",
  "profile.theme.system": "سیستم",
  "profile.theme.dark": "تیره",
  "profile.theme.light": "روشن",
  "profile.glass": "شفافیت شیشه‌ای",
  "profile.glassHint": "روی گوشی‌های ضعیف خاموش کن",
  "profile.language": "زبان و تقویم",
  "profile.locale": "زبان",
  "profile.digits": "اعداد فارسی",
  "profile.calendar": "تقویم",
  "profile.calendar.persian": "شمسی",
  "profile.calendar.gregory": "میلادی",
  "profile.notifications": "اعلان‌ها",
  "profile.about": "درباره",
  "profile.terms": "قوانین",
  "profile.privacy": "حریم خصوصی",
  "profile.version": "نسخه {version}",
  "profile.deleteAccount": "حذف حساب",
  "notifications.title": "اعلان‌ها",
  "notifications.markAll": "خواندن همه",
  "notifications.empty": "اعلانی نداری",
  "notifications.enable.title": "از تأخیر و تغییر گیت باخبر شو",
  "notifications.enable.body": "اجازه بده اعلان بفرستیم تا قبل از همه بدانی.",
  "notifications.enable.cta": "فعال‌سازی اعلان",
  "notifications.pref.delay": "تأخیر",
  "notifications.pref.gate": "تغییر گیت/سکو",
  "notifications.pref.boarding": "زمان سوارشدن",
  "notifications.pref.arrival": "رسیدن",
  "notifications.pref.tripReminder": "یادآوری سفر",
  "notifications.pref.reviewReply": "پاسخ به نظر",
  "notifications.pref.quietHours": "ساعت سکوت",
  "share.title": "اشتراک سفر",
  "share.includeTickets": "شامل بلیت‌ها؟",
  "share.includeBudget": "شامل بودجه؟",
  "share.copyLink": "کپی لینک",
  "share.revoke": "لغو اشتراک",
  "share.public.cta": "با تریپی برنامه‌ریزی کن",
  "pwa.install.title": "تریپی را روی صفحهٔ اصلی بگذار",
  "pwa.install.body": "سریع‌تر باز می‌شود و اعلان می‌گیری.",
  "pwa.install.ios.step1": "دکمهٔ Share را بزن",
  "pwa.install.ios.step2": "«Add to Home Screen» را انتخاب کن",
  "pwa.install.ios.step3": "«Add» را بزن",
  "pwa.install.cta": "نصب",
  "pwa.install.later": "بعداً",
  "transport.flight": "پرواز",
  "transport.train": "قطار",
  "transport.bus": "اتوبوس",
  "transport.airline": "ایرلاین",
  "transport.company": "شرکت",
  "tickets.title": "بلیت‌ها",
  "tickets.all": "همهٔ بلیت‌ها",
  "tickets.upcoming": "پیش رو",
  "tickets.past": "گذشته",
  "tickets.empty.title": "هنوز بلیتی نداری",
  "tickets.empty.body": "بلیت هواپیما، قطار یا اتوبوس اضافه کن و زنده روی نقشه دنبالش کن.",
  "tickets.noTripTickets": "بلیتی به این سفر وصل نشده.",
  "tickets.attachExisting": "اتصال بلیت موجود",
  "tickets.detach": "جدا کردن از سفر",
  "addTicket.step.mode": "نوع",
  "addTicket.step.find": "جست‌وجو",
  "addTicket.step.confirm": "تأیید",
  "addTicket.modeTitle": "با چی سفر می‌کنی؟",
  "addTicket.findTitle": "{mode} خودت رو پیدا کن",
  "addTicket.byNumberHint": "شماره‌ای که روی بلیت چاپ شده رو وارد کن",
  "addTicket.route": "مسیر",
  "addTicket.pickStation": "انتخاب",
  "addTicket.origin": "مبدأ",
  "addTicket.destination": "مقصد",
  "addTicket.results": "{n} نتیجه",
  "addTicket.noResultsBody": "برای این روز چیزی پیدا نشد. تاریخ دیگری امتحان کن یا دستی اضافه کن.",
  "addTicket.manual": "افزودن دستی",
  "addTicket.depTime": "ساعت حرکت",
  "addTicket.arrTime": "ساعت رسیدن",
  "addTicket.seat": "صندلی",
  "addTicket.coach": "واگن",
  "addTicket.pnr": "کد رزرو",
  "addTicket.price": "قیمت (تومان)",
  "addTicket.role.outbound": "رفت",
  "addTicket.role.return": "برگشت",
  "addTicket.role.other": "سایر",
  "addTicket.noTrip": "بدون سفر",
  "addTicket.trackNow": "دنبال کن",
  "addTicket.demoTitle": "دموی زنده",
  "addTicket.demoBody": "یک پرواز شبیه‌سازی‌شدهٔ ۳ دقیقه‌ای بساز و ردیابی زنده رو ببین.",
  "addTicket.demoStart": "شروع پرواز دمو",
  "addTicket.pastServiceHint": "این سرویس قبلاً حرکت کرده.",
  "tracking.title": "ردیابی زنده",
  "tracking.map": "نقشه",
  "tracking.status": "وضعیت",
  "tracking.eta": "زمان رسیدن",
  "tracking.etd": "زمان حرکت",
  "tracking.duration": "مدت",
  "tracking.remaining": "باقی‌مانده",
  "tracking.distance": "مسافت",
  "tracking.speed": "سرعت",
  "tracking.altitude": "ارتفاع",
  "tracking.aircraft": "هواپیما",
  "tracking.vehicle": "وسیله",
  "tracking.number": "شماره",
  "tracking.date": "تاریخ",
  "tracking.onTime": "سر وقت",
  "tracking.delayed": "{n} دقیقه تأخیر",
  "tracking.early": "{n} دقیقه زودتر",
  "tracking.was": "قبلاً {time}",
  "tracking.gateNotAssigned": "هنوز اعلام نشده",
  "tracking.liveDot": "زنده",
  "tracking.reconnecting": "در حال اتصال مجدد…",
  "tracking.offlinePolling": "به‌روزرسانی هر دقیقه",
  "tracking.step.scheduled": "برنامه‌ریزی‌شده",
  "tracking.step.arriving": "در حال رسیدن",
  "tracking.event.status_changed": "وضعیت: {to}",
  "tracking.event.delay_changed": "تأخیر {to} دقیقه",
  "tracking.event.eta_changed": "زمان رسیدن جدید {to}",
  "tracking.event.gate_changed": "گیت {to}",
  "tracking.event.platform_changed": "سکوی {to}",
  "tracking.event.position_first": "موقعیت دریافت شد",
  "tracking.noEvents": "هنوز تغییری ثبت نشده",
  "tracking.removeConfirm": "این بلیت حذف بشه؟",
  "tracking.removed": "بلیت حذف شد",
  "tracking.attachToTrip": "اتصال به سفر",
  "tracking.attached": "به سفر وصل شد",
  "tracking.openTrip": "باز کردن سفر",
  "tracking.passenger": "مسافر",
  "tracking.notify": "تغییرات رو به من خبر بده",
  "tracking.shareText": "{kind} {number} من رو زنده در تریپی دنبال کن",
  "tracking.centerOnVehicle": "مرکز روی وسیله",
  "tracking.fitRoute": "کل مسیر",
  "today.nextTicket": "بلیت بعدی",
  "today.trackLive": "ردیابی زنده",
  "today.otherTickets": "بلیت‌های دیگر",
  "today.seeAllTickets": "همهٔ بلیت‌ها",
  "today.arrivedRecently": "رسید",
  "reviews.sort.rating_high": "بالاترین امتیاز",
  "reviews.sort.rating_low": "پایین‌ترین امتیاز",
  "reviews.withPhotos": "با عکس",
  "reviews.all": "همه",
  "reviews.stars": "{n} ستاره",
  "reviews.count": "{n} نظر",
  "reviews.edit": "ویرایش نظر",
  "reviews.delete": "حذف نظر",
  "reviews.deleted": "نظر حذف شد",
  "reviews.updated": "نظر ویرایش شد",
  "reviews.yours": "نظر شما",
  "reviews.reply": "پاسخ",
  "reviews.replies": "{n} پاسخ",
  "reviews.replyPlaceholder": "پاسخی بنویس…",
  "reviews.send": "ارسال",
  "reviews.showReplies": "نمایش همهٔ پاسخ‌ها",
  "reviews.reportTitle": "گزارش این نظر",
  "reviews.reportReason.spam": "اسپم یا تبلیغ",
  "reviews.reportReason.offensive": "توهین‌آمیز",
  "reviews.reportReason.irrelevant": "بی‌ربط به این مکان",
  "reviews.reportReason.fake": "جعلی یا گمراه‌کننده",
  "reviews.reportReason.other": "سایر",
  "reviews.reported": "ممنون؛ بررسی می‌کنیم",
  "reviews.visitedOn": "کِی رفتی؟",
  "reviews.draftSaved": "پیش‌نویس ذخیره شد",
  "reviews.uploading": "در حال آپلود…",
  "reviews.photoTooLarge": "عکس خیلی بزرگ است (حداکثر ۱۰ مگابایت)",
  "reviews.photoFailed": "آپلود ناموفق؛ دوباره امتحان کن",
  "reviews.tooShort": "کمی بیشتر بنویس (حداقل ۲۰ نویسه)",
  "reviews.mine.title": "نظرهای من",
  "reviews.mine.empty": "هنوز جایی رو نقد نکردی.",
  "reviews.helpfulShort": "{n}",
  "notifications.empty.title": "هنوز خبری نیست",
  "notifications.empty.body": "تأخیرها، تغییر گیت و یادآوری سفرها این‌جا می‌آیند.",
  "notifications.markAllRead": "همه خوانده شد",
  "notifications.settings": "تنظیمات اعلان",
  "notifications.push.title": "اعلان‌های زنده بگیر",
  "notifications.push.body": "برای سوارشدن، تأخیر، تغییر گیت و یادآوری‌ها خبرت می‌کنیم؛ فقط چیزهای مهم.",
  "notifications.push.enable": "فعال‌سازی اعلان‌ها",
  "notifications.push.later": "بعداً",
  "notifications.push.enabled": "اعلان‌ها فعال شد",
  "notifications.push.denied": "اعلان‌ها در تنظیمات مرورگرت مسدود شده.",
  "notifications.push.unsupported": "این مرورگر از اعلان پشتیبانی نمی‌کند.",
  "notifications.push.iosInstallFirst": "روی آیفون اول تریپی رو به صفحهٔ اصلی اضافه کن تا اعلان بگیری.",
  "notifications.push.test": "ارسال اعلان آزمایشی",
  "notifications.push.devices": "این دستگاه",
  "notifications.pref.departures": "سوارشدن و حرکت",
  "notifications.pref.delays": "تأخیر و تغییر زمان رسیدن",
  "notifications.pref.gates": "تغییر گیت و سکو",
  "notifications.pref.planner": "یادآوری سفر",
  "notifications.pref.social": "پاسخ به نظرهای من",
  "notifications.pref.general": "اخبار و نکته‌ها",
  "notifications.pref.quiet": "ساعت سکوت",
  "notifications.pref.quietBody": "فقط لغو شدن‌ها رد می‌شوند.",
  "notifications.pref.from": "از",
  "notifications.pref.to": "تا",
  "pwa.install.button": "نصب",
  "pwa.install.ios.title": "افزودن به صفحهٔ اصلی",
  "pwa.update.title": "نسخهٔ جدید آماده است",
  "pwa.update.button": "به‌روزرسانی",
  "pwa.offline.cached": "آفلاینی — داده‌های ذخیره‌شده نمایش داده می‌شود",
  "profile.myReviews": "نظرهای من",
  "profile.installApp": "نصب برنامه",
  "common.to": "به",
  "today.myTrips": "سفرهای من",
  "today.searchAdd": "شمارهٔ پرواز، قطار یا اتوبوس…",
  "today.section.live": "در مسیر",
  "today.section.upcoming": "پیش رو",
  "today.section.trips": "سفرها",
  "today.section.recent": "اخیر",
  "today.newTrip": "سفر جدید",
  "today.planCta": "یک سفر برنامه‌ریزی کن",
  "today.planCtaBody": "شهر و تاریخ را بگو؛ هتل، برنامهٔ روزانه و بودجه را ما می‌چینیم.",
  "today.nextStep": "قدم بعدی",
  "today.idle.cta": "شروع سفر",
  "today.idle.country": "ایران",
  "today.mapStyle": "سبک نقشه",
  "common.tripCount": "{n} سفر",
  "tracking.untilDeparture": "تا حرکت",
  "tracking.untilArrival": "تا رسیدن",
  "tracking.minutes": "دقیقه",
  "tracking.chip.inAir": "در پرواز",
  "tracking.chip.enRoute": "در مسیر",
  "tracking.chip.arrived": "رسید",
  "tracking.chip.cancelled": "لغو",
  "tracking.chip.boarding": "سوارشدن",
  "tracking.chip.arriving": "در حال رسیدن",
  "tracking.departsIn": "حرکت تا {t}",
  "tracking.arrivesIn": "رسیدن تا {t}",
  "tracking.landsIn": "فرود تا {t}",
  "tracking.departsOnTime": "حرکت به‌موقع",
  "tracking.departsLate": "حرکت با {n} دقیقه تأخیر",
  "tracking.arrivesOnTime": "رسیدن به‌موقع",
  "tracking.arrivesLate": "رسیدن با {n} دقیقه تأخیر",
  "tracking.onTimeShort": "به‌موقع",
  "tracking.lateShort": "{n} دقیقه تأخیر",
  "tracking.departedAt": "حرکت کرد • {t}",
  "tracking.arrivedAt": "رسید • {t}",
  "tracking.band.onTime": "به‌موقع است",
  "tracking.band.onTimeSub": "حرکت طبق برنامه در {t}",
  "tracking.band.delayed": "{n} دقیقه تأخیر",
  "tracking.band.delayedSub": "زمان جدید حرکت {t}",
  "tracking.band.boarding": "در حال سوارشدن",
  "tracking.band.boardingSub": "حرکت تا {t} دیگر",
  "tracking.band.gateIn": "خروج از گیت تا {t}",
  "tracking.band.enRoute": "در مسیر",
  "tracking.band.enRouteSub": "رسیدن تا {t} دیگر • {pct}٪ مسیر",
  "tracking.band.arriving": "در حال رسیدن",
  "tracking.band.arrivingSub": "تا {t} دیگر می‌رسد",
  "tracking.band.arrived": "رسید",
  "tracking.band.arrivedSub": "{t} • {delta}",
  "tracking.band.cancelled": "لغو شد",
  "tracking.band.cancelledSub": "این سرویس اجرا نمی‌شود",
  "tracking.band.unknown": "وضعیت نامشخص",
  "tracking.originBlock": "مبدأ",
  "tracking.destBlock": "مقصد",
  "tracking.forecast": "پیش‌بینی وقت‌شناسی",
  "tracking.forecastSub": "عملکرد این سرویس در ۶۰ روز گذشته",
  "tracking.forecast.early": "زودتر",
  "tracking.forecast.ontime": "به‌موقع",
  "tracking.forecast.late15": "۱۵ دقیقه تأخیر",
  "tracking.forecast.late30": "۳۰ دقیقه تأخیر",
  "tracking.forecast.late45": "بیش از ۴۵ دقیقه",
  "tracking.forecast.cancelled": "لغو",
  "tracking.forecast.onTimeRate": "به‌موقع",
  "tracking.forecast.avgLate": "میانگین تأخیر",
  "tracking.forecast.noData": "هنوز داده‌ای برای این مسیر نداریم",
  "tracking.goodToKnow": "خوب است بدانی",
  "tracking.wagonShort": "واگن",
  "passport.title": "گذرنامهٔ سفر",
  "passport.subtitle": "آمار سفرهای تو با تریپی",
  "passport.allTime": "همهٔ زمان‌ها",
  "passport.flights": "پرواز",
  "passport.trains": "قطار",
  "passport.buses": "اتوبوس",
  "passport.trips": "سفر",
  "passport.cities": "شهر",
  "passport.hours": "ساعت در راه",
  "passport.per": "تعداد سفر بر اساس",
  "passport.perYear": "سال",
  "passport.perMonth": "ماه",
  "passport.perWeekday": "روز هفته",
  "passport.distance": "مسافت طی‌شده",
  "passport.avgDistance": "میانگین هر بلیت: {d}",
  "passport.aroundIran": "دور مرزهای ایران",
  "passport.tehranMashhad": "تهران تا مشهد",
  "passport.toMoon": "تا ماه",
  "passport.empty": "هنوز بلیتی ثبت نکرده‌ای. اولین بلیتت را اضافه کن تا گذرنامه‌ات شروع شود.",
  "passport.longest": "طولانی‌ترین سفر",
  "passport.topRoute": "پرتکرارترین مسیر",
  "passport.onTimeRate": "درصد به‌موقع",
  "profile.passport": "گذرنامهٔ سفر",
  "trips.new": "سفر جدید",
  "trips.nights": "{n} شب",
  "trips.daysCount": "{n} روز",
  "insights.title": "بینش هوشمند",
  "insights.subtitle": "خلاصهٔ هوشمند از تاریخچه، حال‌وهوا و نظر مردم",
  "insights.sentiment": "حس مردم",
  "insights.positives": "نکات مثبت",
  "insights.negatives": "نکات منفی",
  "insights.source.curated": "بر پایهٔ داده‌های تریپی",
  "insights.source.llm": "تولیدشده با هوش مصنوعی",
  "insights.loading": "در حال جمع‌بندی…",
  "insights.error": "فعلاً بینشی در دسترس نیست",
  "auth.rateLimitedMin": "سقف درخواست کد پر شده؛ حدود {minutes} دقیقهٔ دیگر دوباره تلاش کن",
  "trips.warn.noHotels": "هتلی با این بودجه در داده‌های ما نبود؛ خودت انتخاب کن.",
  "trips.warn.hotelOverBudget": "هتل انتخاب‌شده از سهم بودجهٔ اقامت بیشتر است.",
  "trips.warn.generic": "بخشی از برنامه را نتوانستیم کامل کنیم.",
  "trips.warn.noRestaurant": "برای {slot} روز {days} رستوران پیشنهادی نداریم؛ جای خالی را خودت پر کن.",
  "trips.warn.slot.lunch": "ناهار",
  "trips.warn.slot.dinner": "شام",
  "trips.warn.slot.breakfast": "صبحانه",
  "trips.warn.slot.cafe": "کافه",
  "common.listSep": "، ",
  "common.and": "و"
}
